import type { DataTableDesignTokens, DataTableTokenSections } from '@primeuix/themes/types/datatable';

// Rebrand 2026 (#1119): p-table on the Cleverly DS — sand header/hairlines,
// orange selected rows. Previously p-table had no token file at all.
export const headerCell: DataTableTokenSections.HeaderCell = {
    background: '{sand.50}',
    borderColor: '{sand.200}',
    color: '{sand.950}',
    hoverBackground: '{sand.100}',
    padding: '12px 14px',
    gap: '8px'
};

export const bodyCell: DataTableTokenSections.BodyCell = {
    borderColor: '{sand.200}',
    padding: '12px 14px'
};

export const footerCell: DataTableTokenSections.FooterCell = {
    borderColor: '{sand.200}',
    padding: '12px 14px'
};

export const columnTitle: DataTableTokenSections.ColumnTitle = {
    fontWeight: '600'
};

export const row: DataTableTokenSections.Row = {
    background: '#FFFFFF',
    hoverBackground: '{sand.50}',
    selectedBackground: '{primary.100}',
    color: '{sand.950}',
    hoverColor: '{sand.950}',
    selectedColor: '{primary.700}'
};

export const root: DataTableTokenSections.Root = {
    borderColor: '{sand.200}'
};

export const colorScheme: DataTableTokenSections.ColorScheme = {
    light: {
        headerCell: {
            background: '{sand.50}',
            borderColor: '{sand.200}',
            color: '{sand.950}',
            hoverBackground: '{sand.100}'
        },
        bodyCell: {
            borderColor: '{sand.200}'
        },
        row: {
            background: '#FFFFFF',
            hoverBackground: '{sand.50}',
            selectedBackground: '{primary.100}',
            color: '{sand.950}',
            selectedColor: '{primary.700}'
        }
    }
};

export default {
    root,
    headerCell,
    columnTitle,
    row,
    bodyCell,
    footerCell,
    colorScheme
} satisfies DataTableDesignTokens;
